<template>
  <div class="card p-3 shadow">
    <h4 class="font-weight-bolder text-primary pb-3">
      پرفروش ترین های ماه
    </h4>
    <div class="row">
      <div class="col-6" dir="ltr">
        <p class="p-0 m-0">سال</p>
        <select @change="changePage(1)" v-model="form.year" class="custom-select">
          <option v-for="year in years" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
      </div>

      <div class="col-6" dir="ltr">
        <p class="p-0 m-0">ماه</p>
        <select @change="changePage(1)" v-model="form.month" class="custom-select">
          <option v-for="month in months" :key="month.value" :value="month.value">
            {{ month.name }}
          </option>
        </select>
      </div>
    </div>


    <table class="table text-center">
      <thead>
      <tr>
        <th scope="col">نام محصول</th>
        <th scope="col">تعداد فروش</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in topSellProducts">
        <td>{{ item.name }}</td>
        <td class="text-center">{{ item.order_count }}</td>
      </tr>

      </tbody>
    </table>
    <div class="text-center mx-auto">
      <pagination :meta="pagination" :on-change-page="changePage"/>
    </div>
  </div>
</template>

<script>
import Pagination from "../../dashboard/Pagination.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "StatisticTopSellProductOfMonth",
  components: {datePicker: VuePersianDatetimePicker, Pagination},
  data() {
    return {
      form: {
        page: 1,
        month: parseInt(new Date().toLocaleDateString('fa-IR-u-nu-latn', {month: '2-digit'})),
        year: new Date().toLocaleDateString('fa-IR-u-nu-latn', {year: 'numeric'}),
      },
      pagination: [],
      topSellProducts: [],
      months: [
        { value: 1, name: 'فروردین' },
        { value: 2, name: 'اردیبهشت' },
        { value: 3, name: 'خرداد' },
        { value: 4, name: 'تیر' },
        { value: 5, name: 'مرداد' },
        { value: 6, name: 'شهریور' },
        { value: 7, name: 'مهر' },
        { value: 8, name: 'آبان' },
        { value: 9, name: 'آذر' },
        { value: 10, name: 'دی' },
        { value: 11, name: 'بهمن' },
        { value: 12, name: 'اسفند' }
      ]
    }
  },
  computed:{
    years() {
      const currentYear = Number(
          new Intl.DateTimeFormat('fa-IR-u-ca-persian-nu-latn', {
            year: 'numeric'
          }).format(new Date())
      )

      const list = []
      for (let i = -5; i <= 5; i++) {
        list.push(currentYear + i)
      }

      // مقدار اولیه فرم = سال فعلی
      if (!this.form.year) {
        this.form.year = currentYear
      }

      return list
    }
  },
  methods: {
    getTopSellProducts(form) {
      this.$store.dispatch('Statistic/topSellProductOfMonth', form).then(res => {
        let baseData = res.data.data;
        this.topSellProducts = baseData.data
        this.pagination = baseData.meta
      });
    },
    changePage(page) {
      this.form.page = page
      this.getTopSellProducts(this.form)
    },
  },
  mounted() {
    this.getTopSellProducts(this.form)
  }
}
</script>

<style scoped>

</style>